import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
  loading: false,
  userData: null,
  error: null,
  admin: null,
  users: [],
  feedback:[],
  expertuser: [],
  restore: [],
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADMIN_LOGIN_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      };
    case actionTypes.ADMIN_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //GET ADMIN PROFILE
    case actionTypes.GET_ADMIN_PROFILE_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_ADMIN_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        admin: action.payload,
        error: null,
      };
    case actionTypes.GET_ADMIN_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //GET ALL  USERS
    case actionTypes.GET_ALL_USER_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_ALL_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //GET EXPERT  USERS
    case actionTypes.GET_EXPERT_USER_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_EXPERT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        expertuser: action.payload,
        error: null,
      };
    case actionTypes.GET_ALL_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //DELETE  USERS
    case actionTypes.DELETE_USER_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.DELETE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //GET RECYCLE DATA
    case actionTypes.GET_RECYCLE_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_RECYCLE_SUCCESS:
      return {
        ...state,
        loading: false,
        restore: action.payload,
        error: null,
      };
    case actionTypes.GET_RECYCLE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //RESTORE USER ACCOUNT  
    case actionTypes.RESTORE_USER_ACCOUNT_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.RESTORE_USER_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.RESTORE_USER_ACCOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
   //GET USER FEEDBACK   

    case actionTypes.GET_USERS_FEEDBACK_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_USERS_FEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        feedback: action.payload,
        error: null,
      };
    case actionTypes.GET_USERS_FEEDBACK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //DELETE  FEEDBACK
    case actionTypes.USER_FEEDBACK_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.USER_FEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.USER_FEEDBACK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default AuthReducer;
